import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../shared/lib/query-keys.ts";
import { getAuditLogs } from "../api/audit-log-api.ts";
import type { AuditLogData } from "../types/index.ts";

export function useAuditLogsQuery(params: {
  limit: number;
  offset: number;
  actionType: string;
  triggerSource: string;
  status: string;
  search: string;
}) {
  return useQuery<AuditLogData>({
    queryKey: queryKeys.auditLog.list(params),
    queryFn: () => getAuditLogs(params),
    gcTime: 0,
  });
}
